import { showToast } from "./ui";

function toDatetimeLocalValue(d: Date): string {
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/**
 * Send-now vs schedule sheet. Returns ISO scheduled_at, "" for send now, or null if cancelled.
 */
export async function openSendTimingSheet(opts: {
  title?: string;
  kindLabel?: string;
}): Promise<string | "" | null> {
  const kind = opts.kindLabel || "document";
  const defaultWhen = new Date(Date.now() + 60 * 60 * 1000);
  return new Promise((resolve) => {
    const overlay = document.createElement("div");
    overlay.className = "sheet-overlay";
    overlay.innerHTML = `
      <div class="sheet" role="dialog" aria-modal="true" aria-label="${opts.title || `Send ${kind}`}">
        <div class="sheet-handle" aria-hidden="true"></div>
        <h3 class="sheet-title">${opts.title || `Send ${kind}`}</h3>
        <div class="sheet-body">
          <p class="hint">Send now, or pick a date and time to schedule.</p>
          <div class="field">
            <label for="schedule-send-at">Schedule for</label>
            <input id="schedule-send-at" type="datetime-local" value="${toDatetimeLocalValue(defaultWhen)}" />
          </div>
        </div>
        <div class="sheet-actions">
          <button type="button" class="btn ghost" data-action="cancel">Cancel</button>
          <button type="button" class="btn secondary" data-action="schedule">Schedule</button>
          <button type="button" class="btn primary" data-action="now">Send now</button>
        </div>
      </div>`;
    const finish = (value: string | "" | null) => {
      document.body.classList.remove("sheet-open");
      overlay.remove();
      resolve(value);
    };
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) finish(null);
    });
    overlay.querySelector('[data-action="cancel"]')?.addEventListener("click", () => finish(null));
    overlay.querySelector('[data-action="now"]')?.addEventListener("click", () => finish(""));
    overlay.querySelector('[data-action="schedule"]')?.addEventListener("click", () => {
      const input = overlay.querySelector("#schedule-send-at") as HTMLInputElement | null;
      const raw = String(input?.value || "").trim();
      if (!raw) {
        showToast("Pick a date and time.", "error");
        return;
      }
      const ms = Date.parse(raw);
      if (!Number.isFinite(ms)) {
        showToast("Invalid date and time.", "error");
        return;
      }
      if (ms <= Date.now() + 30_000) {
        finish("");
        return;
      }
      finish(new Date(ms).toISOString());
    });
    document.body.classList.add("sheet-open");
    document.body.appendChild(overlay);
  });
}

export function formatScheduledAt(iso: unknown): string {
  const s = String(iso || "").trim();
  if (!s) return "";
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}
